<template>
  <div>
    <component-table
      entity-type="profile"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      :hide-add-button="true"
      @view="goToProfile($event.id)"
      @edit="goToEdit($event.id)"
      @delete="showDeleteDialog($event.id)"
      @roles="goToRoles($event.id)"
    />
  </div>
</template>

<script>
import ComponentTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { DELETE_ACTION, EDIT_ACTION, ROLES_ACTION, VIEW_ACTION } from '@/utils/constants';

// @vuese
// Lista profili
// @group Profile
export default {
  components: { ComponentTable },

  mixins: [
    listMixin('profile', {
      listError: 'Wystąpił błąd podczas pobierania profili.',
      getError: 'Wystąpił błąd podczas pobierania danych profilu.',
      added: 'Dodano profil.',
      addError: 'Nie udało się dodać profilu.',
      updated: 'Zaktualizowano dane profilu.',
      updateError: 'Nie udało się zaktualizować danych profilu.',
      deleteConfirm: 'Czy na pewno chcesz usunąć profil?',
      deleted: 'Usunięto profil.',
      deleteError: 'Nie udało się usunąć profilu.'
    })
  ],

  data() {
    return {
      columns: [{ name: 'email', displayName: 'Nazwa użytkownika', action: VIEW_ACTION.event }],
      actions: [
        { ...VIEW_ACTION, permissions: 'USER.GET' },
        { ...ROLES_ACTION, permissions: 'USER.ROLE_MANAGE' },
        { ...EDIT_ACTION, permissions: 'USER.UPDATE' },
        { ...DELETE_ACTION, permissions: 'USER.DELETE' }
      ]
    };
  },

  methods: {
    // @vuese
    // Przenosi do szczegółów profilu
    goToProfile(profileId) {
      this.$router.push({ name: 'profile', params: { profileId } });
    },
    // @vuese
    // Przenosi do edycji
    goToEdit(profileId) {
      this.$router.push({ name: 'profileEdit', params: { profileId } });
    },
    // @vuese
    // Przenosi do edycji ról
    goToRoles(profileId) {
      this.$router.push({ name: 'profileRoles', params: { profileId } });
    }
  }
};
</script>
